/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Scope_Point_4Inputs */

const en_svc_rag_scope_point_4 = /** @type {(inputs: Svc_Rag_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers with citations, and a hand-off when sources are missing`)
};

const lv_svc_rag_scope_point_4 = /** @type {(inputs: Svc_Rag_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildes ar atsaucēm un nodošana cilvēkam, ja avotu trūkst`)
};

/**
* | output |
* | --- |
* | "Answers with citations, and a hand-off when sources are missing" |
*
* @param {Svc_Rag_Scope_Point_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_scope_point_4 = /** @type {((inputs?: Svc_Rag_Scope_Point_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Scope_Point_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_scope_point_4(inputs)
	return en_svc_rag_scope_point_4(inputs)
});